import { createApp } from "vue";
import App from "./App.vue";
import router from "./router";
import store from "./store";

// Vuetify
import "vuetify/styles";
import { createVuetify } from "vuetify";
import * as components from "vuetify/components";
import * as directives from "vuetify/directives";

// Mdi
import "@mdi/font/css/materialdesignicons.css";

const vuetify = createVuetify({
  components,
  directives,
  theme: {
    defaultTheme: 'light',
    themes: {
      light: {
        dark: false,
        variables: {},

        colors: {
          background: "#F8FCEC",
          surface: "#FFFFFF",
          primary: "#FFC107",
          "primary-darken-1": "#FFA000",
          secondary: "#FF5722",
          "secondary-darken-1": "#E64A19",
          error: "#E91E63",
          info: "#2196F3",
          success: "#4CAF50",
          warning: "#FFEB3B",
        },
      },
      dark: {
  dark: true,
  colors: {
    background: "#111A14",  // negro con tinte verde lima
    surface:    "#1A2820",  // superficie verdosa
    primary:    "#FFC107",
    "primary-darken-1": "#FFA000",
    secondary:  "#FF5722",
    "secondary-darken-1": "#E64A19",
    error:   "#E91E63",
    info:    "#2196F3",
    success: "#4CAF50",
    warning: "#FFEB3B",
  }
}
    },
  },
});

createApp(App).use(store).use(router).use(vuetify).mount("#app");
